import { memo, useCallback, useEffect, useState } from "react"
import ListUi from "./ListUi"
import { useDispatch } from 'react-redux'
import { callApiAction } from "../../store/actions/commonAction"

import { closeModal, openModal } from "../../store/actions/modalAction"
import { Box, CircularProgress, IconButton, Switch, Typography } from "@mui/material"
import { useMemo } from "react"
import CreateController from "./CreateController"
import { Delete, Edit, KeyboardArrowRight } from "@mui/icons-material"
import { FetchPatientApi } from "../../apis/patient.api"
import TinnitusTestApp from "../hearingTest/HearingTestController"
import { useLocation, useNavigate } from "react-router-dom"

const ActionComponent = memo(({ params, setParams, deleteApi }) => {
    const dispatch = useDispatch()

const navigate = useNavigate();
const location = useLocation();

    const onEdit = () => {
        dispatch(openModal(<CreateController id={params._id} callBack={(response, updatedData) => {
            setParams({ ...params, ...updatedData })
        }} />, "sm"))
    }

    const onclickButton = () =>{
        navigate(`/Patient-Details/${params._id}`,{

          })
    }

    return <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
        {/* <IconButton size="inherit" onClick={onEdit}>
            <Edit color="info" fontSize="inherit" />
        </IconButton> */}
        <IconButton size="inherit" onClick={onclickButton} >
            <KeyboardArrowRight sx={{color:"#d34646"}} fontSize="inherit" />
        </IconButton>

    </Box>
})



const ListController = () => {
    const dispatch = useDispatch()



    const title = "Patient List"
    const fetchApi = FetchPatientApi
    const deleteApi = null


    const columns = useMemo(() => [

        { id: 1, fieldName: 'name', label: 'Patient Name', align: "left", sort: true },
        { id: 2, fieldName: 'phone', label: 'phone ', align: "left",sort: false, renderValue: (params, setParams) => params?.phone },
        { id: 3, fieldName: 'email', label: 'email', align: "left", sort: false },
        { id: 5, fieldName: 'age', label: 'age', align: "left", sort: false },
        { id: 4, fieldName: 'address', label: 'address', align: "left", sort: false },
        {
            id: 5,
            fieldName: '',
            label: '',
            align: "right",
            renderValue: (params, setParams) => <ActionComponent deleteApi={deleteApi} params={params} setParams={setParams} />,
        },

    ], [dispatch]);


    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: '',
        searchable: ['name'],
        sort: 'createdAt',
        sortDirection: -
        1

    })





    // do not change 

    const [loading, setLoading] = useState(false)
    const [list, setList] = useState({})









    const fetchList = () => {
        setLoading(true)
        dispatch(callApiAction(
            async () => await fetchApi({ ...filters }),
            (response) => {
                setList(response)
                setLoading(false)
            },
            (err) => {
                setLoading(false)
            }
        ))
    }
    const onCreateBtnClick = () => {
        dispatch(openModal(<CreateController callBack={async () => { fetchList() }} />, "sm",false, "Create"))
    }



    useEffect(() => {
        fetchList()
    }, [filters])



    return (
        <>
            <ListUi
                title={title}
                onCreateBtnClick={onCreateBtnClick}

                filters={filters}
                setFilters={setFilters}
                loading={loading}
                list={list}
                columns={columns}


            />

        </>
    )
}
export default ListController